var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #757575;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.6,17s7.8-3.2,10.6-3.6c1.4-.2,4.4,.2,5.2,1,.2,.2,1,1.4,1,1.4,0,0,4.4,2.2,4.8,2.4,1,.8-4.2,1.8-4.2,1.8l2.4,10.8c1,3.8,4,6.8,7.6,7.8l16.4,3.6c1.6,.4,2.8,1.2,4,2.2l2.2,2.4c1,1.2,1.2,2.8,.2,4l2.2,6.8c.4,1.2,1.4,2.2,2.6,2.6l2.4,.8c1,.4,1.6,1,1.8,2l1,3.8c.6,2.2,1.6,4.2,3,6l4.2,5h-5.6l-7.8-11.4-8-.4-9.6-9.6-20.8-5.8-6.2,.4-7.2-2.2s.4,.6,.6,1l2,3.4c.6,1.4,1.6,2.6,2.8,3.4l5.8,4.4-2.8,1.4-7.2-4-7.8-12.2c-.4-.6-.2-1.6,.4-2l.8-.6c.6-.4,1.4-.6,2-.4l12.2,1.2-2.2-10.2,1.8-10.2-4.6-2.6-5-1.2s-1-3.2-1-3.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.2,2.2s-.2,3.2-1.8,6.4c-.6,1.4-3.2,5-3.2,5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.4,5.4s.8,1.6,1.8,2.6,2.4,1.4,2.4,1.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeer);
export default __webpack_public_path__ + "static/media/deer.c099aa662d10e8eb72ea652abf801079.svg";
export { ForwardRef as ReactComponent };